<mat-accordion>
  <mat-expansion-panel expanded="true" togglePosition="before">
    <mat-expansion-panel-header>
      <mat-panel-title>Deal Status Legend</mat-panel-title>
    </mat-expansion-panel-header>

    <div class="deal-status-legend">
      <div class="deal-status-legend__item flex items-center mb-2" *ngFor="let item of legendItems">
        <span
          [ngStyle]="getItemStyle(item)"
          class="deal-status-legend__icon rounded-full"
          [ngClass]="getItemClass(item)"
        ></span>
        <span class="deal-status-legend__description">{{ item.label }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
